export default __webpack_public_path__ + "static/media/productx3.0743f0f9.png";